import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import i18n from 'i18next';

import { withTranslation } from 'react-i18next';
import { translationSuffixes } from '../../constants';

class TooltipWrapper extends React.Component {
  getTranslatedTooltip = () => {
    const { t, tooltip, label, tooltipClassName } = this.props;
    let translatedTooltip;
    if (tooltip && i18n.exists(tooltip)) {
      translatedTooltip = t(tooltip);
    } else if (label && i18n.exists(label + translationSuffixes.tooltip)) {
      translatedTooltip = t(label + translationSuffixes.tooltip);
    } else {
      translatedTooltip = tooltip;
    }
    return (
      <>
        {translatedTooltip && (
          <Popup
            className={tooltipClassName}
            wide="very"
            on={['hover', 'click']}
            basic
            trigger={<Icon link={true} name="info circle" size="small" />}
          >
            <Popup.Content>
              <div dangerouslySetInnerHTML={{ __html: translatedTooltip }} />
            </Popup.Content>
          </Popup>
        )}
      </>
    );
  };

  render() {
    return this.getTranslatedTooltip();
  }
}

export default withTranslation()(TooltipWrapper);
